import DiagnosisQuestionTemplate from '~/pages/anatomyV2/libs/components/DiagnosisQuestionTemplate'
import { DIAGNOSIS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/diagnosisCorrectAnswers'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 5

const DiagnosisShoulderAnatomyV2 = (props: TPageProps) => (
  <DiagnosisQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.diagnosisShoulder.title"
    caseTextI18nKey="onboarding.diagnosisShoulder.caseText"
    options={[
      {
        key: 'gallbladder',
        i18nKey: 'onboarding.diagnosisShoulder.options.gallbladder',
      },
      {
        key: 'rotatorCuff',
        i18nKey: 'onboarding.diagnosisShoulder.options.rotatorCuff',
      },
      {
        key: 'neckNerve',
        i18nKey: 'onboarding.diagnosisShoulder.options.neckNerve',
      },
    ]}
    correctOptionKey={
      DIAGNOSIS_CORRECT_ANSWERS[PageId.DIAGNOSIS_SHOULDER_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.diagnosisShoulder.correctTitle"
    correctExplanationI18nKey="onboarding.diagnosisShoulder.correctExplanation"
    incorrectTitleI18nKey="onboarding.diagnosisShoulder.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.diagnosisShoulder.incorrectExplanation"
    question="Diagnosis: shoulder pain case"
  />
)

export default DiagnosisShoulderAnatomyV2
